import ProductConfirmController from "./product_confirm_controller"

// Doc: _docs/features/products/partner_products_index.md
export default class extends ProductConfirmController {
  get errorMessage() {
    return "No se pudo archivar el producto. Inténtalo de nuevo."
  }
}
